import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
  [action.GET_PANEL_LIST](state, data) {
    state.panelWidgets = data;
  },
  [action.PANEL_TOGGLE](state, widget) {
    const foundIndex =
    state.disableWidgets.length > 0
        ? state.disableWidgets.findIndex((x) => x.id == widget.id)
        : -1;
    if (foundIndex !== -1) {
      state.disableWidgets.splice(foundIndex, 1);
    } 
    state.disableWidgets.push(widget);

  },
  [action.PANEL_DISABLE](state) {
    let disableWidgetsKey = "disableWidgets#"+sessionStorage.getItem("tenantId");
    const disableWidgets = localStorage.getItem(disableWidgetsKey)
      ? JSON.parse(localStorage.getItem(disableWidgetsKey))
      : [];
    state.disableWidgets = disableWidgets;
    state.panelWidgets = state.panelWidgets.map((obj) => {
      const foundIndex = disableWidgets.findIndex((d) => d.id == obj.id);
      return foundIndex !== -1 && obj.id === disableWidgets[foundIndex].id
        ? { ...obj, isShow: disableWidgets[foundIndex].isShow }
        : obj;
    });
  },
  [action.WIDGET_ENABLE](state) {
    state.panelWidgets = state.panelWidgets.map((obj) => {
      return { ...obj, isShow: true };
    });
  },
  [action.ADD_PANEL](state, data) {
      const isShow = { isShow: true };
      const widget = { ...isShow, ...data };
      state.panelWidgets.push(widget)
  },
  [action.UPDATE_PANEL](state, data) {
    const foundIndex = state.panelWidgets.findIndex((x) => x.id == data.id);
    if (foundIndex !== -1) {
      const disablePanel = state.disableWidgets.findIndex((x) => x.id == state.panelWidgets[foundIndex].id);
      data.isShow = state.disableWidgets[disablePanel]?.isShow ?? false
      state.panelWidgets.splice(foundIndex, 1, data);
    } 
  },
  [action.REMOVE_PANEL](state, id) {
    const foundIndex = state.panelWidgets.findIndex((x) => x.id == id);
    if (foundIndex !== -1) {
      state.panelWidgets.splice(foundIndex, 1);
    } 
  },
  setLastRow(state, index) {
    state.lastRowIndex = index;
  },
  resetDisableWidgets(state) {
    state.disableWidgets = [];
  },
  [action.RESET_STATE](state) {
    Object.assign(state, initialState);
},
};

export default mutations;
